import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Card, CardBody, CardGroup, Col, Form, Row } from 'reactstrap'

import isEmpty from '../../../utils/isEmpty'
import CustomInputGroup from '../../../common/InputGroup'

function LoginForm({ loginUser, history, auth, errors, fromPathname, forgotPassword }) {
  const [values, setValues] = useState({ email: '', password: '' })

  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState({
    email: {},
  })

  useEffect(() => {
    if (!isEmpty(errors) && !isEmpty(errors.errors)) {
      const errorObj = {}
      errors.errors.map((error) => {
        return (errorObj[error.path[0]] = {
          errorMessage: error.message,
        })
      })
      setError(errorObj)
    }
  }, [errors])

  useEffect(() => {
    if (auth) {
      history.push(`${fromPathname}`)
    }
    // eslint-disable-next-line
  }, [auth])

  const onChange = (e) => {
    const { name, value } = e.target
    setValues({ ...values, [name]: value })
  }

  const onLoginClick = (e) => {
    e.preventDefault()

    const { email, password } = values

    const userData = {
      email,
      password,
    }

    loginUser(userData)
  }

  const onPasswordResetClick = () => {
    const { email } = values
    forgotPassword(email)
  }

  return (
    <Col md='6'>
      <CardGroup>
        <Card className='p-4'>
          <CardBody>
            <Form onSubmit={onLoginClick} row='true'>
              <h1>Login</h1>
              <p className='text-muted'>Sign In to your account</p>
              <CustomInputGroup
                label='Email'
                onChange={onChange}
                name='email'
                value={values.email}
                type='text'
                placeholder='Email'
                autoComplete='email'
                invalid={!isEmpty(errors) && !isEmpty(errors.email) ? true : false}
                errorMess={!isEmpty(errors) && !isEmpty(errors.email) ? errors.email : null}
              />
              <CustomInputGroup
                label='Password'
                onChange={onChange}
                name='password'
                value={values.password}
                type='password'
                placeholder='Password'
                invalid={!isEmpty(errors) && !isEmpty(errors.password)}
                errorMess={!isEmpty(errors) && !isEmpty(errors.password) ? errors.password : null}
              />
              {/* </InputGroup> */}
              <Row style={{ marginTop: '30px' }}>
                <Col xs='6'>
                  <Button className={'btn btn-gold'} type='submit'>
                    Login
                  </Button>
                </Col>
                <Col xs='6' className='text-right'>
                  <Button color='link' className='px-0' type='button' onClick={onPasswordResetClick}>
                    Forgot password?
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </CardGroup>
    </Col>
  )
}

LoginForm.propTypes = {
  loginUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  auth: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
}

export default withRouter(LoginForm)
